import {
  Divider,
  Tab,
  TabProps as TabPropsMUI,
  Tabs as TabsMUI,
  TabsProps as TabsPropsMUI,
} from '@mui/material';
import { FunctionComponent, PropsWithChildren, useState } from 'react';

export type TabProps = {
  props: TabPropsMUI;
  element: React.ReactNode;
};

export type TabsProps = {
  tabs: TabProps[];
  Container?: FunctionComponent<PropsWithChildren>;
} & TabsPropsMUI;

export const Tabs: FunctionComponent<TabsProps> = (props) => {
  const { Container, tabs, ...tabsProps } = props;
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <>
      <TabsMUI {...tabsProps} onChange={handleChange} value={activeTab}>
        {tabs.map(({ props }, index) => (
          <Tab key={index} {...props} />
        ))}
      </TabsMUI>
      <Divider sx={{ mb: 1 }} />
      {Container ? (
        <Container>{tabs.at(activeTab)?.element}</Container>
      ) : (
        tabs.at(activeTab)?.element
      )}
    </>
  );
};
